export const OrgsRouteId = 'shell.orgs/orgs';
